import script from "./PatientCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientCard.vue?vue&type=script&setup=true&lang=js"

import "./PatientCard.vue?vue&type=style&index=0&id=4065c2ae&lang=scss&scoped=true"
import "./PatientCard.vue?vue&type=style&index=1&id=4065c2ae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4065c2ae"]])

export default __exports__